import { ReactNode } from "react";

import { useDrop } from "react-dnd";

import { DragTypes } from "../../models/DragTypes";
import { ILead } from "../../models/Lead";
import classNames from "../../utils/classNames";

type IProps = {
  // Called when a lead is dropped on a cell with no trip yet; the parent
  // confirms, creates the trip, then drops the lead into it.
  onDropLead: (lead: ILead) => void;
  children: ReactNode;
};

export default function EmptyTripSlot({ onDropLead, children }: IProps) {
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: DragTypes.EVENT,
      drop: (lead: ILead) => onDropLead(lead),
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
      }),
    }),
    [onDropLead]
  );

  return (
    <div
      ref={drop}
      className={classNames(
        "h-full flex items-center justify-center",
        isOver ? "bg-primary-200" : ""
      )}
      style={{
        opacity: isOver ? 0.8 : 1,
      }}
    >
      {children}
    </div>
  );
}
